/**
 * Generated by orval v6.28.2 🍺
 * Do not edit manually.
 * Maybern
 * Maybern API
 * OpenAPI spec version: 0.0.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query'
import type {
  CustomerCreateParams
} from '../../model/customerCreateParams'
import type {
  CustomerData
} from '../../model/customerData'
import type {
  CustomerDataList
} from '../../model/customerDataList'
import type {
  CustomerDataRequest
} from '../../model/customerDataRequest'
import { axiosRequest } from '../../../shared/api/Api';


      
type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];



      import { appQueryClient } from "app/AppQueryClient";
      import { LoaderFunction, Params } from "@remix-run/router";
      import { isLoggedIn } from "axios-jwt";

      const authedLoader = (loader: LoaderFunction): LoaderFunction =>
        async (args) => {
          const result = await isLoggedIn();
          if (result) {
            return loader(args);
          }
          return null;
        };
    /**
 * Lists all customers for user
 */
export const customerList = (
    
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<CustomerDataList>(
      {url: `/customer/`, method: 'GET', signal
    },
      options);
    }
  

export const getCustomerListQueryKey = () => {
    return [`/customer/`] as const;
    }

    
export const getCustomerListQueryOptions = <TData = Awaited<ReturnType<typeof customerList>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customerList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCustomerListQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof customerList>>> = ({ signal }) => customerList(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof customerList>>, TError, TData> & { queryKey: QueryKey }
}

export type CustomerListQueryResult = NonNullable<Awaited<ReturnType<typeof customerList>>>
export type CustomerListQueryError = unknown

export const useCustomerList = <TData = Awaited<ReturnType<typeof customerList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customerList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCustomerListQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCustomerListSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof customerList>>, TError = unknown>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof customerList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCustomerListQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof customerList>>> = ({ signal }) => customerList(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof customerList>>, TError, TData> & { queryKey: QueryKey }
}

export type CustomerListSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof customerList>>>
export type CustomerListSuspenseQueryError = unknown

export const useCustomerListSuspense = <TData = Awaited<ReturnType<typeof customerList>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof customerList>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCustomerListSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getCustomerListLoader = (): LoaderFunction =>
        authedLoader(() => appQueryClient.prefetchQuery({
          queryKey: getCustomerListQueryKey(),
          queryFn: () => customerList(),
        }).then(() => null));
      /**
 * Creates a customer
 */
export const customerCreate = (
    customerDataRequest: CustomerDataRequest,
    params?: CustomerCreateParams,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<CustomerData>(
      {url: `/customer/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: customerDataRequest,
        params
    },
      options);
    }
  


export const getCustomerCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof customerCreate>>, TError,{data: CustomerDataRequest;params?: CustomerCreateParams}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof customerCreate>>, TError,{data: CustomerDataRequest;params?: CustomerCreateParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof customerCreate>>, {data: CustomerDataRequest;params?: CustomerCreateParams}> = (props) => {
          const {data,params} = props ?? {};

          return  customerCreate(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CustomerCreateMutationResult = NonNullable<Awaited<ReturnType<typeof customerCreate>>>
    export type CustomerCreateMutationBody = CustomerDataRequest
    export type CustomerCreateMutationError = unknown

    export const useCustomerCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof customerCreate>>, TError,{data: CustomerDataRequest;params?: CustomerCreateParams}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getCustomerCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Deletes customer user relation data. This will DELETE the users association with the customer!!!
 */
export const internalCustomerUserRelationDestroy = (
    customerId: string,
    userId: string,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<void>(
      {url: `/customer/${customerId}/user/${userId}/relation/`, method: 'DELETE'
    },
      options);
    }
  


export const getInternalCustomerUserRelationDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof internalCustomerUserRelationDestroy>>, TError,{customerId: string;userId: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof internalCustomerUserRelationDestroy>>, TError,{customerId: string;userId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof internalCustomerUserRelationDestroy>>, {customerId: string;userId: string}> = (props) => {
          const {customerId,userId} = props ?? {};

          return  internalCustomerUserRelationDestroy(customerId,userId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type InternalCustomerUserRelationDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof internalCustomerUserRelationDestroy>>>
    
    export type InternalCustomerUserRelationDestroyMutationError = unknown

    export const useInternalCustomerUserRelationDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof internalCustomerUserRelationDestroy>>, TError,{customerId: string;userId: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getInternalCustomerUserRelationDestroyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Gets customer data for a specific customer.
 */
export const customerRetrieve = (
    id: string,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<CustomerData>(
      {url: `/customer/${id}/`, method: 'GET', signal
    },
      options);
    }
  

export const getCustomerRetrieveQueryKey = (id: string,) => {
    return [`/customer/${id}/`] as const;
    }

    
export const getCustomerRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof customerRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customerRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCustomerRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof customerRetrieve>>> = ({ signal }) => customerRetrieve(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof customerRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CustomerRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof customerRetrieve>>>
export type CustomerRetrieveQueryError = unknown

export const useCustomerRetrieve = <TData = Awaited<ReturnType<typeof customerRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customerRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCustomerRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCustomerRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof customerRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof customerRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCustomerRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof customerRetrieve>>> = ({ signal }) => customerRetrieve(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof customerRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CustomerRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof customerRetrieve>>>
export type CustomerRetrieveSuspenseQueryError = unknown

export const useCustomerRetrieveSuspense = <TData = Awaited<ReturnType<typeof customerRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof customerRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCustomerRetrieveSuspenseQueryOptions(id,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getCustomerRetrieveLoader = (paramsOrFn?: (Params | ((params: Params) => ({ id: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { id } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
          if (id) {
            return appQueryClient.prefetchQuery({
              queryKey: getCustomerRetrieveQueryKey(id),
              queryFn: () => customerRetrieve(id),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Updates customer data.
 */
export const customerUpdate = (
    id: string,
    customerDataRequest: CustomerDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<CustomerData>(
      {url: `/customer/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: customerDataRequest
    },
      options);
    }
  


export const getCustomerUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof customerUpdate>>, TError,{id: string;data: CustomerDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof customerUpdate>>, TError,{id: string;data: CustomerDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof customerUpdate>>, {id: string;data: CustomerDataRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  customerUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CustomerUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof customerUpdate>>>
    export type CustomerUpdateMutationBody = CustomerDataRequest
    export type CustomerUpdateMutationError = unknown

    export const useCustomerUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof customerUpdate>>, TError,{id: string;data: CustomerDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getCustomerUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Deletes customer data. This will DELETE all underlying data!!
 */
export const customerDestroy = (
    id: string,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<void>(
      {url: `/customer/${id}/`, method: 'DELETE'
    },
      options);
    }
  


export const getCustomerDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof customerDestroy>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof customerDestroy>>, TError,{id: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof customerDestroy>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  customerDestroy(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CustomerDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof customerDestroy>>>
    
    export type CustomerDestroyMutationError = unknown

    export const useCustomerDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof customerDestroy>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getCustomerDestroyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    